import {route} from '@/router/route-utils'

const prefix = '/admin/users';

const routes = [

    route(
        prefix, 'admin.users.list', {
            components : {
                main: () => import('./views/AdminUsersListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Admin',
            breadcrumb: [
                {text: 'Admin', active: true},
            ],
        }
    ),

];

export default routes
